import React from 'react';
import { AlertTriangle } from 'lucide-react';

function WiderrufPage() {
  return (
    <div className="container mx-auto px-4 lg:px-12 py-8 max-w-4xl">
      <h1 className="text-3xl md:text-4xl font-heading font-bold mb-8 uppercase">
        Widerrufsbelehrung
      </h1>

      <div className="prose prose-gray max-w-none space-y-6">
        {/* Wichtiger Hinweis */}
        <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-lg">
          <div className="flex items-start gap-3">
            <AlertTriangle className="h-6 w-6 text-amber-600 flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="text-lg font-bold text-amber-800 mb-2">Wichtiger Hinweis für Geschäftskunden (B2B)</h2>
              <p className="text-amber-700">
                Unser Online-Shop richtet sich <strong>ausschließlich an Unternehmer</strong> im 
                Sinne von § 14 BGB (Gewerbetreibende, Freiberufler, juristische Personen).
              </p>
            </div>
          </div>
        </div>

        {/* Kein Widerrufsrecht */}
        <section className="bg-gray-100 rounded-lg p-6">
          <h2 className="text-xl font-bold mb-4">Kein gesetzliches Widerrufsrecht</h2>
          <p className="text-gray-700">
            Das gesetzliche Widerrufsrecht gemäß §§ 355 ff. BGB steht <strong>ausschließlich 
            Verbrauchern</strong> im Sinne von § 13 BGB zu.
          </p>
          <p className="text-gray-700 mt-3">
            Da unser Angebot ausschließlich an <strong>Unternehmer (B2B)</strong> gerichtet ist, 
            besteht für Bestellungen in unserem Shop <strong>kein gesetzliches Widerrufsrecht</strong>.
          </p>
        </section>

        {/* Kulanzregelungen */}
        <section>
          <h2 className="text-xl font-bold mb-4">Kulanzregelungen</h2>
          <p className="text-gray-700">
            Ungeachtet des fehlenden gesetzlichen Widerrufsrechts sind wir bemüht, 
            kundenfreundliche Lösungen zu finden.
          </p>
          <p className="text-gray-700 mt-3">
            In begründeten Einzelfällen können wir nach individueller Prüfung eine Rücknahme 
            der Ware gegen Gutschrift oder Erstattung anbieten. Bitte kontaktieren Sie uns 
            hierzu:
          </p>
          <div className="bg-white border border-gray-200 rounded-lg p-4 mt-4">
            <p className="text-gray-700">
              <strong>ED STEEL</strong><br />
              E-Mail: ed-steel@outlook.de<br />
              Telefon: +49 171 629 5816
            </p>
          </div>
          <p className="text-gray-600 text-sm mt-4 italic">
            Hinweis: Auf Kulanzregelungen besteht kein Rechtsanspruch. Eine eventuelle 
            Rücknahme erfolgt ausschließlich nach vorheriger Absprache.
          </p>
        </section>

        {/* Gewährleistung */}
        <section>
          <h2 className="text-xl font-bold mb-4">Gewährleistungsrechte bleiben unberührt</h2>
          <p className="text-gray-700">
            Das Fehlen eines Widerrufsrechts berührt nicht Ihre gesetzlichen 
            Gewährleistungsansprüche bei mangelhafter Ware. Diese richten sich nach den 
            gesetzlichen Bestimmungen sowie unseren Allgemeinen Geschäftsbedingungen.
          </p>
          <p className="text-gray-700 mt-3">
            Bei Mängeln an der gelieferten Ware wenden Sie sich bitte unverzüglich an uns.
          </p>
        </section>

        {/* Rechtsgrundlage */}
        <section className="bg-gray-50 rounded-lg p-6">
          <h2 className="text-xl font-bold mb-4">Rechtsgrundlage</h2>
          <p className="text-gray-700">
            § 312g Abs. 1 BGB i.V.m. § 312 Abs. 1 BGB: Das Widerrufsrecht bei 
            Fernabsatzverträgen gilt nur für Verbraucher.
          </p>
          <p className="text-gray-700 mt-2">
            § 14 BGB: Definition des Unternehmers – eine natürliche oder juristische Person, 
            die bei Abschluss eines Rechtsgeschäfts in Ausübung ihrer gewerblichen oder 
            selbständigen beruflichen Tätigkeit handelt.
          </p>
        </section>

        {/* Stand */}
        <section className="pt-4 border-t border-gray-200">
          <p className="text-gray-500 text-sm">
            Stand: Februar 2026
          </p>
        </section>
      </div>
    </div>
  );
}

export default WiderrufPage;
